import { render, staticRenderFns } from "./VendorDetailFrontend.vue?vue&type=template&id=41b21b01&"
import script from "./VendorDetailFrontend.vue?vue&type=script&lang=js&"
export * from "./VendorDetailFrontend.vue?vue&type=script&lang=js&"
import style0 from "./VendorDetailFrontend.vue?vue&type=style&index=0&id=41b21b01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports